import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { NgModule } from '@angular/core';
import { AplicacionRoutingModule,ROUTABLE_COMPONENTS} from './aplicacion.routing';
import { MatTableModule} from '@angular/material';
import { AplicacionService } from './shared/aplicacion.service';
import { MatButtonModule, MatInputModule, MatIconModule, MatCheckboxModule,MatSlideToggleModule,MatFormFieldModule,MatPaginatorModule, } from '@angular/material';
import { FabButtonGroupModule } from '../../../shared/fabbuttongroup/fabbuttongroup.module';
import { SectionBarModule } from '../../../shared/sectionbar/sectionbar.module';

//components
import { AplicacionListComponent } from './list/aplicacion-list.component';
import { ApplicationViewComponent } from './view/aplicacion-view.component';
import { ApplicationEditComponent } from './edit/aplicacion-edit.component';
import { ApplicationNewComponent } from './new/aplicacion-new.component';
import { AplicacionComponent } from './aplicacion.component';
import { RolListComponent } from './listRol/rol-list.component';

//ccontrols
import { TitlebarModule } from '../../../shared/titlebar/titlebar.module';
import { HeaderModule } from '../../../shared/header/header.module';
import { LoaderModule } from '../../../shared/loader/loader.module';
import { SnackbarModule } from '../../../shared/snackbar/snackbar.module';
import { GridEmptyModule } from 'src/app/shared/gridempty/gridempty.module';
import { AplicacionRolListComponent } from './listRol/aplicacion-rol-list.component';

@NgModule({
    imports: [
      BrowserModule,
      MatTableModule,
      MatIconModule,
      AplicacionRoutingModule,
      MatCheckboxModule, MatButtonModule, MatInputModule, MatPaginatorModule,
      FormsModule, ReactiveFormsModule,
      FabButtonGroupModule,
      SectionBarModule, MatSlideToggleModule, GridEmptyModule,
      TitlebarModule, HeaderModule, LoaderModule, SnackbarModule
    ],
    entryComponents: [],
    exports: [],
    declarations: [
        AplicacionListComponent,
        ApplicationViewComponent,
        ApplicationEditComponent,
        ApplicationNewComponent,
        RolListComponent,
        AplicacionRolListComponent,
        AplicacionComponent,
        ROUTABLE_COMPONENTS
    ],
    providers: [AplicacionService],
    bootstrap: []
})
export class AplicacionModule {
}
